export const translateCodes = {
    //#region [Common words]
    DRAFT: 'DRAFT',
    BACK: 'BACK',
    OK: 'OK',
    NEXT: 'NEXT',
    CANCEL: 'CANCEL',
    DELETE: 'DELETE',
    SAVE: 'SAVE',
    EDIT: 'EDIT',
    REVERT: 'REVERT',
    VIEW: 'VIEW',
    CREATE: 'CREATE',
    APPLY: 'APPLY',
    CLEAR_ALL: 'CLEAR_ALL',
    CHOOSE_FILE: 'CHOOSE_FILE',
    //#endregion [Common words]

    //#region [Tax words]
    TAX: 'TAX',
    CREATE_TAX: 'CREATE_TAX',
    //#endregion [Tax words]

    //#region [Calendar words]
    ADD_BREAK: 'ADD_BREAK',
    BREAK: 'BREAK',
    ADD_TIME_OFF: 'ADD_TIME_OFF',
    VIEW_EMPLOYEE_DETAIL: 'VIEW_EMPLOYEE_DETAIL',
    EDIT_THIS_DAY: 'EDIT_THIS_DAY',
    EDIT_WORKING_HOUR: 'EDIT_WORKING_HOUR',
    REVERT_EMAIL_TEMPLATE: 'REVERT_EMAIL_TEMPLATE',
    MESSAGE_CONFIRM_REVERT_EMAIL_TEMPLATE: 'MESSAGE_CONFIRM_REVERT_EMAIL_TEMPLATE',
    //#endregion [Calendar words]

    //Table
    TABLE_EMPTY_DESCRIPTION: 'TABLE_EMPTY_DESCRIPTION',
    TABLE_EMPTY_TITLE: 'TABLE_EMPTY_TITLE',
    TABLE_SEARCH_EMPTY_DESCRIPTION: 'TABLE_SEARCH_EMPTY_DESCRIPTION',
    TABLE_SEARCH_EMPTY_TITLE: 'TABLE_SEARCH_EMPTY_TITLE',
    TREE_EMPTY_DATA: 'TREE_EMPTY_DATA',
    ACTIVITY_HISTORY: 'ACTIVITY_HISTORY',
    PIN_TO_MINIMIZE: 'PIN_TO_MINIMIZE',
    CANCEL_SALE: 'CANCEL_SALE',
    FILTER: 'FILTER',

    //#region [Day]
    MONDAY: 'MONDAY',
    TUESDAY: 'TUESDAY',
    WEDNESDAY: 'WEDNESDAY',
    THURSDAY: 'THURSDAY',
    FRIDAY: 'FRIDAY',
    SATURDAY: 'SATURDAY',
    SUNDAY: 'SUNDAY',
    DAY: 'DAY',
    START_TIME: 'START_TIME',
    FINISH_TIME: 'FINISH_TIME',
    DURATION: 'DURATION',
    //#endregion [Day]

    //#region [Bad Request]
    //Sale
    SALE_NOT_FOUND: 'SALE_NOT_FOUND',
    SALE_ALREADY_EXISTS: 'SALE_ALREADY_EXISTS',
    PAYMENT_METHOD_REQUIRED: 'PAYMENT_METHOD_REQUIRED',
    SALE_DETAIL_REQUIRED: 'SALE_DETAIL_REQUIRED',
    SERVICE_DELETED: 'SERVICE_DELETED',
    PRODUCT_DELETED: 'PRODUCT_DELETED',
    SALE_PAYMENT_INVALID: 'SALE_PAYMENT_INVALID',
    SALE_HAS_BEEN_CHECKOUT: 'SALE_HAS_BEEN_CHECKOUT',
    PACKAGE_REQUIRE_CUSTOMER: 'PACKAGE_REQUIRE_CUSTOMER',
    CHANGE_CUSTOMER_REQUIRE_REMOVE_PACKAGE: 'CHANGE_CUSTOMER_REQUIRE_REMOVE_PACKAGE',
    CUSTOMER_PACKAGE_OUT_OF_LIMIT: 'CUSTOMER_PACKAGE_OUT_OF_LIMIT',
    PACKAGE_HAS_BEEN_USE_AT_OTHER_SALE: 'PACKAGE_HAS_BEEN_USE_AT_OTHER_SALE',

    //#endregion [Bad Request]
};

export type TranslateResources = Record<keyof typeof translateCodes, string>;
